import { Component, OnInit } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';
import packageInfo from 'package.json';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { Router } from '@angular/router';
import { NativeCheckService } from 'src/app/services/native-check.service';

@Component({
  selector: 'libero-unauth-footer',
  templateUrl: './unauth-footer.component.html',
  styleUrl: './unauth-footer.component.scss',
  standalone: false
})
export class UnauthFooterComponent implements OnInit {
  public appVersion = '';

  public currentYear = new Date().getFullYear();

  public get displayOverflow(): boolean{
    return this.router.url.includes('/login');
  }

  public constructor(
    private loggerService: LoggerService,
    public router: Router,
    private nativeCheckService: NativeCheckService,
  ) {}

  public ngOnInit(): void {
    this.setVersion();
  }

  private setVersion(): void {
    try {
      this.appVersion = packageInfo.version;
      this.loggerService.logInfo(this.appVersion);
    } catch (error) {
      this.loggerService.error('Failed to set app version!', error);
    }
  }

  public get isNativePhone(): boolean {
    return this.nativeCheckService.isNativePlatform();
  }

  public reopenCookieModal(): void {
    CookieConsent.show(true);
  }
}
